/**
 * @license Copyright (c) 2015, Hypermedia
 * For licensing, see LICENSE
 */

"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";
import NowellonEditableFieldPropType from "../NowellonEditableField";

class ShareSocialBox extends Component {
    getDefaultProps() {
        return {
            "className": "socialBox blueSocial",
            "ShareLocation": window.location.href,
            "ShareDomain": window.location.origin,
            "FacebookShareOn": "SHARE ON"
        };
    }
    getFacebookShareLink() {
        var facebookText;
        var facebookShareURL;
        if (this.props.SocialShareCopyTextFacbook && this.props.SocialShareCopyTextFacbook.Value !== "") {
            facebookText = this.props.SocialShareCopyTextFacbook.Value;
            facebookShareURL = "https://www.facebook.com/sharer.php?u=" + encodeURIComponent(this.props.FacebookLink.Value) + "&t=" + encodeURI(this.stripHTMLTags(facebookText));
        }
        return facebookShareURL;
    }
    getTwitterShareLink() {
        var twitterText;
        var twitterShareURL;
        if (this.props.SocialShareCopyTextTwitter && this.props.SocialShareCopyTextTwitter.Value !== "") {
            twitterText = this.props.SocialShareCopyTextTwitter.Value;
            twitterShareURL = "http://twitter.com/intent/tweet?text=" + encodeURI(this.stripHTMLTags(twitterText));
        }
        return twitterShareURL;
    }
    getPinterestShareLink() {
        var pinterestText;
        var pinterestShareURL;
        if (this.props.SocialShareCopyTextPinttrest && this.props.SocialShareCopyTextPinttrest.Value !== "") {
            pinterestText = this.props.SocialShareCopyTextPinttrest.Value;
            pinterestShareURL = "http://pinterest.com/pin/create/button/?url=" + encodeURIComponent(this.props.PinterestLink) + "&description=" + encodeURI(this.stripHTMLTags(pinterestText)) + "&media=" + encodeURIComponent(this.props.ShareDomain);
        }
        return pinterestShareURL;
    }
    stripHTMLTags(value) {
         return value.replace(/(<([^>]+)>)/ig, "");
    }
    propTypes = {
        "className": PropTypes.string,
        "Image": NowellonEditableFieldPropType.isRequired,
        "ShareLocation": PropTypes.string,
        "FacebookShareOn": PropTypes.string
    }
    render() {
        return <div>
            <ul className="clearfix">
                <li className="facebook">
                    <a href={this.getFacebookShareLink()} target="_blank" className="facebookButton ir">Like</a>
                </li>
                <li className="tweeter">
                    <a href={this.getTwitterShareLink()} target="_blank" className="tweetButton ir">Tweet</a>
                </li>
                <li className="pinterest">
                    <a href={this.getPinterestShareLink()} target="_blank" className="pinItButton ir">
                      Pin It
                    </a>
                </li>
            </ul>
        </div>;
    }
};
export default ShareSocialBox;

